
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

@Component({
  components: {
  }
})
export default class ProductDetails extends Vue {
  @InjectReactive() isMobile!: boolean;
  @Getter activeRestaurant!: Restaurant;
  @Prop({ default: false }) isGroupOrder: boolean;
  @Prop() quantity: number;
  @Prop() minQuantity: number;
  @Prop() specialInstructions: string;

  get quant() {
    return this.quantity;
  }

  set quant(quant) {
    this.$emit('quantityChange', quant);
  }

  get instructions() {
    return this.specialInstructions;
  }

  set instructions(instructions) {
    this.$emit('instructionsChange', instructions);
  }

  handleQuantityChange(event) {
    let newValue = parseInt(event.target.value, 10);
    if (newValue < this.minQuantity) {
      newValue = this.minQuantity;
    } else if (newValue > 99) {
      newValue = 99
    }
    this.quant = newValue
  }

  get specialInstructionsHelpText() {
    if (this.activeRestaurant.specialInstructionsHelpText && this.activeRestaurant.specialInstructionsHelpText !== '') {
      return this.activeRestaurant.specialInstructionsHelpText;
    }
    return 'Any special instructions?';
  }
}
